import { decorateFIX } from './utilsfixparaserview'
import * as _ from 'underscore'

export function processFIX(fixText){
    var fixs = parseFIX(fixText);
    if (fixs.error) {
        return fixs.error
    }
    var decoratedFixs = decorateFIX(fixs);
    return decoratedFixs;
}

function parseFIX(fixText){
    //TODO check bad or misformed messages
    //if (fixText.length === 0) { throw "No text found, please paste well formed FIX messages or click 'Sample data'";}

    var msgArr = fixText.match(/[^0-9a-zA-Z:\s]*8=FIX(.*?)[^0-9]10=\d\d\d.?/g);//TODO: match tags 8,9,35
    if (msgArr === null) { 
        return {error: "No well formed FIX string found"}
    }

    var delimiter = guessDelimiter(msgArr[0]);

    var fixs = new Array(msgArr.length);

    for(var i = 0; i < msgArr.length; i++){
        fixs[i] = convertToObject(msgArr[i], delimiter);
        //console.log(JSON.stringify(fixs[i]));
    }

    return fixs;
}

function guessDelimiter(fixText){
    //Find end of tag 9 and beginning of tag 35. A char or set of cars between these two fields is the delim
    //--match tag 9 and find its length
    //--search tag 9, find its and location
    //--search tag 35 find its start location
    //--characters between end of tag 9 and start of tag 35 are the delimiter
    try {
        var tag9keyval = fixText.match(/[^0-9]9=[0-9]+/)[0];
        var startOfTag9 = fixText.search(/[^0-9]9=[0-9]+/);
        var endOfTag9 = startOfTag9 + tag9keyval.length;
        var startOfTag35 = fixText.search(/[^0-9]35=/)+1;
        var delim = fixText.slice(endOfTag9,startOfTag35);
        return delim;
    } catch {
        return {error: "No well formed FIX string found"}
    }

    //delimLoc = fixText.search(/[^0-9]9=/g);//TODO: does the 'g' need to be there?
    //return fixText[delimLoc];
}

function convertToObject(fixTextSingle, delimiter){
    var kv = {};
    var keyvals = fixTextSingle.split(delimiter);
    var pairs = _.map(keyvals, function(e){ return e.split('=');});
    for (var i = 0; i < keyvals.length; i++) {
        var pair = pairs[i];

        //check if this key is a dup
        if(false /*_.has(kv,pair[0])*/){
            //dup found!
            var currentIdx = i;
            var prevIdx = i;
            var repeatingGroupKeys = [];
            for(var j = prevIdx-1; j > 1; j--){
                repeatingGroupKeys.push(pairs[j][0]);
                if(pairs[j][0] === pair[0]){
                    //prev idx found
                    prevIdx = j;
                    break;//TODO: what if prev key is never found? impossible under normal circumstances
                }
            }
            var repeatingGroupNoIdx = prevIdx - 1;
            var numOfGroupElements = parseInt(pairs[repeatingGroupNoIdx][1],10);//TODO: possible error, if not int value because dup match happened even though this is not actually a repeating group!
            if(numOfGroupElements > pairs.length){
                //sanity check
                break;
            }
            var gapBetweenDups = currentIdx - prevIdx;
            var endOfGroupIdx = repeatingGroupNoIdx + numOfGroupElements * gapBetweenDups;
            if(endOfGroupIdx > keyvals.length){
                console.error("endOfGroupIdx:"+endOfGroupIdx+" is greater than fix msg size:"+keyvals.length);
            }

            //console.log(JSON.stringify(pairs));
            var group = [];
            for(var k = 0; k < numOfGroupElements; k++){
                var startIdx = prevIdx+k*numOfGroupElements;
                var endIdx = (prevIdx+k*numOfGroupElements)+gapBetweenDups;
                var groupEl = pairs.slice(startIdx, endIdx);
                //group.push(_.object(groupEl));
                //var mappedGroupEL = _.map(groupEl, function(e){ return {tag:e[0], value:e[1]};});
                group.push(groupEl);
                //add this group to kv, render kv in detail table, remove rep grp value from raw kv (before dup detection)

            }
            kv[pairs[repeatingGroupNoIdx][0]] = group;
            //console.log(JSON.stringify(group));

            //remove keys which should not have been added in the first place
            _.each(repeatingGroupKeys, function(e){ delete kv[e]; });

            //move the outer loop forward, since we have already processed next X keys
            i = endOfGroupIdx;
        }
        else{
            kv[pair[0]] = pair[1];
            //console.log("Added "+pair[0]+":"+pair[1]);
        }
    }
    var rslt = {lookup:kv, pairs:pairs};
    return rslt;
}
